import NextLink from 'next/link';
import { addCanalPlusGTMClass } from 'services/lib/util';

const AppImageLink = ({ children, href, target }) => {
  return (
    <NextLink href={href} passHref target={target} className={addCanalPlusGTMClass(href)}>
      {children}
    </NextLink>
  );
};
export default AppImageLink;
